export default "__VITE_PUBLIC_ASSET__07982403__"